export default __webpack_public_path__ + "static/media/logo@2x_2.96e7daae.png";